<template>
  <section class="min-h-screen flex items-stretch text-white bg-[#F7F7F7]">
    <!-- Side Menu -->
    <div class="hidden md:flex flex-col justify-between bg-[#090446] text-white w-1/6 p-4">
      <!-- Top Menu -->
      <div class="sticky top-0 bg-[#090446] p-4 z-20">
        <div>
          <p class="text-lg font-semibold">Total Progress: {{ progressDetail.totalAnswers1+progressDetail.totalAnswers2+progressDetail.totalAnswers3 }}/{{ progressDetail.totalQuestions1+progressDetail.totalQuestions2+progressDetail.totalQuestions3 }}</p>
          <p class="text-lg font-semibold">Part - 1 : {{ progressDetail.totalAnswers1 }}/{{ progressDetail.totalQuestions1 }}</p>
          <p class="text-lg font-semibold">Part - 2: {{ progressDetail.totalAnswers2 }}/{{ progressDetail.totalQuestions2 }}</p>
          <p class="text-lg font-semibold">Part - 3: {{ progressDetail.totalAnswers3 }}/{{ progressDetail.totalQuestions3 }}</p>
          <div class="w-full bg-gray-200 rounded-full h-2.5 mt-2">
            <div class="bg-[#ab064e] h-2.5 rounded-full" :style="{ width: ((progressDetail.totalAnswers1+progressDetail.totalAnswers2+progressDetail.totalAnswers3) / (progressDetail.totalQuestions1+progressDetail.totalQuestions2+progressDetail.totalQuestions3)) * 100 + '%' }"></div>
          </div>
        </div>
      </div>

      <!-- Bottom Menu -->
      <div class="mt-auto">
        <router-link to="/privacy-policy" class="text-white hover:text-[#ab064e]">
          Privacy Policy
        </router-link>
      </div>
    </div>

    <!-- Main Content -->
    <div class="flex-1 flex items-center justify-center py-6 md:px-16 px-0 z-0">
      <div id="login-card" class="w-full sm:max-w-md lg:max-w-lg mx-auto px-6 py-8 z-20 bg-white rounded-[36px] shadow-lg">
        <div class="flex items-center justify-center mb-6">
          <a href="#" class="flex items-center">
            <img src="../assets/images/logo.png" class="h-24" alt="Logo" />
          </a>
        </div>

        <!-- Consent Section -->
        <div v-if="consent">
          <h2 class="text-2xl font-bold mb-4 text-center text-[#090446]">
            Survey Consent
          </h2>
          <p class="text-lg text-black mb-4">
            Mpact International Inc is a 3rd party consulting firm that has been hired to collect information about applicants for any number of roles in organizations. We do not make any hiring decisions and are not agents of the firm for which you are interviewing.
          </p>
          <p class="text-lg text-black mb-4">
            This site collects the following types of data on visitors: web log files detailing pages completed and survey responses based on applicant replies. Data is shared with the hiring team of the firms who retain our services and are not shared with any other third party.
          </p>
          <p class="text-lg text-black mb-4">
            Data from this survey are recorded and used by hiring firms for the purpose of understanding potential hires for their firm. The results of this data is analyzed and released to hiring firms for their use, which is not under the control of Mpact International. By participating in, and submitting, a survey you acknowledge that your answers will be recorded. Your answers are shared with the firm and will be linked to your application.
          </p>
          <p class="text-lg text-black mb-4">
            I consent to participate in this survey.
          </p>

          <!-- Radio Options -->
          <div class="flex flex-col space-y-2 mb-6">
            <label class="flex items-center">
              <input type="radio" v-model="agreement" value="agree" @change="handleAgreementChange" />
              <span class="ml-2 text-black">I agree</span>
            </label>
            <label class="flex items-center">
              <input type="radio" v-model="agreement" value="disagree" @change="handleAgreementChange" />
              <span class="ml-2 text-black">I do not agree</span>
            </label>
          </div>

          <!-- Submit Button -->
          <button
          v-if="agreement === 'agree'"
          @click.prevent="handleContinue"
          class="relative flex items-center justify-center w-full py-2 text-lg text-white bg-[#0A0446] hover:bg-primary-700 focus:ring-4 focus:ring-primary-200 font-medium rounded-lg text-sm px-5 h-10 py-2.5 text-center">
          <svg v-if="isLoading" class="animate-spin h-5 w-5 text-white absolute" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
          </svg>
          <span v-else>Next</span>
        </button>

        </div>
      </div>
    </div>
  </section>
</template>




<script>
import Swal from 'sweetalert2'
import Api from '../router/api'
import AppMixin from '../mixins/AppMixin'

export default {
  name: 'SurveyConsent',
  data() {
    return {
      url: '',
      consent: 1,
      instructions: 0,
      agreement: '', // Use a single data property for radio buttons
      progressDetail: {
        totalQuestions1: 0,
        totalQuestions2: 0,
        totalQuestions3: 0,
        totalAnswers1: 0,
        totalAnswers2: 0,
        totalAnswers3: 0,
      },
      isLoading: 0
    }
  },
  mounted() {
    let urlToken = this.$route.fullPath.split('/')[2]
    this.url = urlToken
    this.getProgressBarDetail(this.url);
  },
  methods: {
    handleAgreementChange() {
      if (this.agreement === 'disagree') {
        Api.getCompanyDetail(this.url).then(response => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'This assessment is part of the screening process for ' + response.data.res + '. Since you are declining, please reach out to the recruitment team to follow up on the next steps.',
            confirmButtonColor: '#0A0446'
          });
        });
      }
    },
    getProgressBarDetail(url) {
      Api.getProgressBarDetail(url).then(response => {
        this.progressDetail.totalQuestions1 = response.data.res.totalQuestions1;
        this.progressDetail.totalQuestions2 = response.data.res.totalQuestions2;
        this.progressDetail.totalQuestions3 = response.data.res.totalQuestions3;
        this.progressDetail.totalAnswers1 = response.data.res.totalAnswers1;
        this.progressDetail.totalAnswers2 = response.data.res.totalAnswers2;
        this.progressDetail.totalAnswers3 = response.data.res.totalAnswers3;
      });
    },
    handleContinue() {
      this.isLoading = 1;
      Api.updateSteps(this.url, 1);
      this.$router.push(`/welcome-page/${this.url}`);
    },
    submitConsent() {
      if (this.agreement === 'agree') {
        this.instructions = true;
        this.consent = false;
      }
    }
  }
}
</script>


<style scoped>
.form-group {
  margin-bottom: 1rem;
}
.err {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/NonEmployeeConsentPage.vue